import { gql } from '@apollo/client';

export type TCombosRequest = {
  input?: {
    q?: string;
    host_group_id: number | null;
  };
  page?: number;
};
export type TCombosResponse = {
  combos: {
    paginatorInfo: {
      currentPage: number;
      lastPage: number;
    };
    data: Array<{
      id: number;
      title: string;
      quantity: number;
      base_price: number;
      price: number;
      host_group?: {
        id: number;
        title: string;
      };
    }>;
  };
};
export const COMBOS = gql`
  query combos($input: SearchComboInput, $page: Int) {
    combos(input: $input, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
      }

      data {
        id
        title
        quantity
        base_price
        price

        host_group {
          id
          title
        }
      }
    }
  }
`;

export type THostGroupsResponse = {
  hostGroupsOverview: Array<{
    id: number;
    title: string;
  }>;
};
export const HOST_GROUPS = gql`
  query hostGroupsOverview {
    hostGroupsOverview {
      id
      title
    }
  }
`;
